import { Component, OnInit } from '@angular/core';
import { PageComponent, PageService, Page, AppConfig } from '@tytapp/common';
import { environment } from 'environment';

@Page('how-to-watch')
@Component({
    selector: 'app-how-to-watch',
    templateUrl: './how-to-watch.component.html',
    styleUrls: ['./how-to-watch.component.scss']
})
export class HowToWatchComponent extends PageComponent {

    constructor(
        pageService: PageService,
        private appConfig: AppConfig
    ) {
        super(pageService);
    }

    table = [
        ['tyt.com', 'assets/how-to-watch/tyt_com.png', 'https://tyt.com', 'Free', null, 'Member', 'Member', 'Member'],
        ['TYT Plus - iOS', 'assets/how-to-watch/tyt_plus_ios.png', 'https://itunes.apple.com/us/app/tyt-plus/id1319576607?mt=8', 'Free', null, 'Member', 'Member', 'Member'],
        ['TYT Plus - Android', 'assets/how-to-watch/tyt_plus_android.png', 'https://play.google.com/store/apps/details?id=com.tyt.battlecruiser', 'Free', null, 'Member', 'Member', 'Member'],
        ['YouTube TV', 'assets/how-to-watch/youtube_tv.png', 'https://tv.youtube.com/browse/tyt-network-UCdc2l-gR0ITUw-kGdXFAOHA', null, null, 'YouTube TV subscription required', 'YouTube TV subscription required', null],
        ['YouTube', 'assets/how-to-watch/youtube.png', 'https://www.youtube.com/user/TheYoungTurks/featured', 'Free', 'Free', 'Selected shows', 'Selected shows', null],
        ['Hulu', 'assets/how-to-watch/hulu.png', 'https://www.hulu.com/network/tyt-network', null, 'Free', 'Selected shows', null, null],
        ['Facebook', 'assets/how-to-watch/facebook.png', 'https://www.facebook.com/TheYoungTurks', 'Free', 'Free', null, null, null],
        ['Twitter', 'assets/how-to-watch/twitter.png', 'https://twitter.com/TheYoungTurks', 'Free', null, null, null, null],
        ['Instagram', 'assets/how-to-watch/instagram.png', 'https://www.instagram.com/theyoungturks', 'Free', null, null, null, null],
        ['Samsung TV Plus', 'assets/how-to-watch/samsung_tv_plus_2.png', 'https://samsungtvplus.com', null, null, 'Selected shows', null, null],
        ['Pluto', 'assets/how-to-watch/pluto.png', 'https://pluto.tv/tv/tyt-network', null, 'Free', null, null, null],
        ['Xumo', 'assets/how-to-watch/xumo.png', 'https://www.xumo.tv/channel/9999147/tyt', 'Free', null, null, null, null],
        ['TCL', 'assets/how-to-watch/tcl.png', null, null, null, 'Selected shows', null, null],
        ['LocalNow', 'assets/how-to-watch/local_now.jpeg', null, null, null, 'Selected shows', null, null],
        ['FuboTV', 'assets/how-to-watch/fubo_tv.png', 'https://qa.fubo.tv/stream/tyt-network/?v=3', null, null, 'Selected shows', null, null],
        ['Aol', 'assets/how-to-watch/aol.png', 'https://www.aol.com/video/partner/the-young-turks/518748891', 'Free', null, null, null, null],
        ['iTunes', 'assets/how-to-watch/itunes.png', 'https://itunes.apple.com/us/genre/podcasts/id26?mt=2', null, null, null, null, 'Free'],
        ['Google Play', 'assets/how-to-watch/google_play.png', 'https://play.google.com/music/listen#/srps/tyt/EAk', null, null, null, null, 'Free'],
        ['Stitcher', 'assets/how-to-watch/stitcher.png', 'https://www.stitcher.com/search?q=tyt', null, null, null, null, 'Free'],
        ['Spotify', 'assets/how-to-watch/spotify.png', 'https://www.spotify.com/us', null, null, null, null, 'Free'],
        ['iHeartRadio', 'assets/how-to-watch/iheart_radio.png', 'https://www.iheart.com', null, null, null, null, 'Free'],
        ['SoundCloud', 'assets/how-to-watch/soundcloud.png', 'https://soundcloud.com/the-young-turks', null, null, null, null, 'Free'],
        ['TuneIn', 'assets/how-to-watch/tune_in.png', 'https://tunein.com/search/?query=tyt', null, null, null, null, 'Free'],
    ];

    async init() {
        this.pageTitle = 'How To Watch';
    }

    get joinUrl() {
        // CHANGE GLOBALLY (at appConfig) NOT HERE
        return environment.urls.purchase;
    }

}
